import React, { ReactElement } from 'react';
import CompanyPageLayout
  from '@fuww/library/src/Layouts/CompanyPage';
import UniqueSellingProposition
  from '@fuww/library/src/UniqueSellingProposition';
import AdaptiveCard from '@fuww/library/src/Cards/AdaptiveCard';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import PageCardContainer from '@fuww/library/src/PageCardContainer';
import Language from '@fuww/library/src/Icons/Language';
import Newspaper from '@fuww/library/src/Icons/Newspaper';
import Work from '@fuww/library/src/Icons/Work';
import Email from '@fuww/library/src/Icons/Email';
import { useIntl } from 'react-intl';
import TextWithImage from '../components/TextWithImage';
import getSourceSet from '../lib/getSourceSet';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import Head from '../components/Head';
import ImageWithUrls from '../components/ImageWithUrls';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import { textWithImageConfigurations, companyProfilesCardImageConfigurations }
  from '../lib/imageConfigurations';
import LinkAndAnchor from '../components/LinkAndAnchor';
import getProxiedImages from '../lib/getProxiedImages';
import { useSiteContext } from '../components/SiteContext';

const imageUrls = {
  premiumEmployer: [
    'https://r.fashionunited.com/_ZGXt33TP5fZBEALSHHB0cIm8s3FjI97x38NNVe1Bm0/resize:fill-down:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLnBuZw',
    'https://r.fashionunited.com/Elx8M0gqrkZA4eJuXlu1BjJM3A4CLXEZM7XE_bxE5Zo/resize:fill-down:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLnBuZw',
    'https://r.fashionunited.com/aafdPx7a5boIXOyx3Wf6Tx1Y0Y_F5jhzCLRr5DXrCbU/resize:fill-down:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLnBuZw',
    'https://r.fashionunited.com/1oiIztnzHoOnau24aa1mU8EEdzL1oWHjW5QOVhfuIBE/resize:fill-down:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLnBuZw',
  ],
  employerBranding: [
    'https://r.fashionunited.com/1zu2T8_jUoQQwR6XA6wLhvjWxQq0ycNvm6TBL5Szxho/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/Q0KiHZcbAOjEvthu5gDicidJx-k4fpsn6oitv3ztjt8/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/USLu0i1fK0QKy1_3xYPwwzxH_gk599UVhtVCXHF7ChI/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/nx_Y09LONwKnZ_2vtoRit0SAaZYa0ZVZGuRksy12RII/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
  ],
  contentMarketing: [
    'https://r.fashionunited.com/ev0ExVV3zYDhXT29CmFEh1XymTQWWAT1wd0Oz7gQN0g/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudF9tYXJrZXRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/5QLV00qhEouiqJw81za-9czVU6iQlHQ1hPjxJxec8hk/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudF9tYXJrZXRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/VOcy6gHUq24M_NO62wUSu0-Ajm7R6A1LAbBj-DnO4Ks/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudF9tYXJrZXRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/Qzh_BwDi2k1z3f370LHdwnv8lcxKptkDXhTVZ8pzKeQ/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvY29udGVudF9tYXJrZXRpbmdfaW1hZ2UucG5n',
  ],
  displayAdvertising: [
    'https://r.fashionunited.com/9tHVCPomkc6c9h2Z1mFhgLCiqu5fkvvZB6_nPPG6F6I/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
    'https://r.fashionunited.com/KHBxxlzuREO5ReaHuFtzJfw3-0MY27h41kp2HYjNnLI/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
    'https://r.fashionunited.com/7gm0dm5mFfmaE9dhD9qs3Nr_O_gycmJfyfbivTQ9Aik/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
    'https://r.fashionunited.com/mDsDXm6UfATKpF1LEgKVIi4MZ-S_rEKFd7t3Ej0nCE0/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
  ],
  newsSubscription: [
    'https://r.fashionunited.com/qLaoLx2et3GcLrKQbwZcNpoKjI2qQblGik1O-vZa2pc/resize:fill-down:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzLXN1YnNjcmlwdGlvbnMucG5n',
    'https://r.fashionunited.com/B-eTDVn_JHNHvFEUomAKeBlNyuKbvIEVHzUSL02K90k/resize:fill-down:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzLXN1YnNjcmlwdGlvbnMucG5n',
    'https://r.fashionunited.com/Uqh_5dXPOCDFEJrZOjOnIi4jt5FxRF4JhWslXgQPoAk/resize:fill-down:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzLXN1YnNjcmlwdGlvbnMucG5n',
    'https://r.fashionunited.com/hqOrXufnTV1jdX2_X_PuvGIE3tnLhQmkXmtUp4FFk38/resize:fill-down:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzLXN1YnNjcmlwdGlvbnMucG5n',
  ],
};

const uniqueSellingPropositionItems = [
  {
    id: 'visitors',
    icon: <Language />,
    text: '1.500.000 monthly visitors',
  },
  {
    id: 'articles',
    icon: <Newspaper />,
    text: '70.000+ articles published',
  },
  {
    id: 'jobs',
    icon: <Work />,
    text: '+ 100.000 jobs',
  },
  {
    id: 'newsletters',
    icon: <Email />,
    text: '30,000,000 newsletters sent per year',
  },
];

const CompanyPage = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();

  const breadcrumbs = [
    <HomeLink key="home" />,
    <span key="company">
      {intl.formatMessage(messages.company)}
    </span>,
  ];

  const cardsData = [
    {
      title: intl.formatMessage(
        messages['companyLandingPage.newsSubscription.title'],
      ),
      description: intl.formatMessage(
        messages[
          'companyLandingPage.newsSubscription.description'
        ],
      ),
      route: 'news-subscription',
      cardImageUrls: [
        'https://r.fashionunited.com/2SBHsndaEgz9kAyHRD85DLPpBOh8d-maYziKhHzruAw/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3cy1zdWJzY3JpcHRpb25zLWNhcmQucG5n',
        'https://r.fashionunited.com/-H6HOIA5xdoK8_-uhBkl3f6PB642OeyE6yEbII0tt1E/resize:fill:288:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3cy1zdWJzY3JpcHRpb25zLWNhcmQucG5n',
        'https://r.fashionunited.com/cG4mgv9o4TGJTt0RH11lTj2BniW3FDIw3pGOR6vEZ3A/resize:fill:318:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3cy1zdWJzY3JpcHRpb25zLWNhcmQucG5n',
        'https://r.fashionunited.com/i6EwQODROsjcE6KBzs694Rdgf0JWUwhRnOD7XU1vvfA/resize:fill:576:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3cy1zdWJzY3JpcHRpb25zLWNhcmQucG5n',
        'https://r.fashionunited.com/nP5g53JtRfUULT_Lk9kwf-FXnKzYakc8EzNALY8UvZQ/resize:fill:636:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3cy1zdWJzY3JpcHRpb25zLWNhcmQucG5n',
        'https://r.fashionunited.com/pR_Ao8eE43My3-5CW9wm2n6bbWT5EGgwm9kVsCtanYM/resize:fill:960:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3cy1zdWJzY3JpcHRpb25zLWNhcmQucG5n',
      ],
    },
    {
      title: 'Advertise',
      description: 'Advertise your brand on FashionUnited',
      route: 'display-advertising',
      cardImageUrls: [
        'https://r.fashionunited.com/g27ZYJDk7DDdG3-gCieHwTR_qTLwisv0_al74d_2qAU/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0aXNlLmpwZw',
        'https://r.fashionunited.com/g3dpNIppdRgo1IfvrKygi-oqBY7KWODs7NXvPFx8N-s/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0aXNlLmpwZw',
        'https://r.fashionunited.com/MKdBZa7R0FuQdPUjqjX_zeEnIC0N0BLeCcaKfrmjVmQ/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0aXNlLmpwZw',
        'https://r.fashionunited.com/c5RiAI9mREfTdXgFManiX89ZgK2zJRm-bsB_ofJa4Tw/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvYWR2ZXJ0aXNlLmpwZw',
      ],
    },
    {
      title: 'Submit your job postings',
      description: 'FashionUnited is there to boost your HR & marketing strategy in various ways',
      route: `submit-job-postings.${locale}`,
      cardImageUrls: [
        'https://r.fashionunited.com/Q99Y9xMaCBuGTCAdMqTTVKFUxkxeoUkPNl-66NW7HD0/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvam9icG9zdGluZy5qcGc',
        'https://r.fashionunited.com/bNakA85yxPSBA0A5YPNUEV71Os1UPAghbKjvbNZ0n4I/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvam9icG9zdGluZy5qcGc',
        'https://r.fashionunited.com/wF9Amt7chCl8H9wOp26pCGVGErcO6H87YMsnpmahAS4/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvam9icG9zdGluZy5qcGc',
        'https://r.fashionunited.com/TUuqn1w-ZY_WtAgGhW2G7p8lG2rv0pnv9U9nhIpZebE/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvam9icG9zdGluZy5qcGc',
      ],
    },
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.company)}
        description={intl.formatMessage(
          messages['companyLandingPage.metaDescription'],
        )}
      />
      <CompanyPageLayout
        breadcrumbs={breadcrumbs}
        title={intl.formatMessage(messages['companyLandingPage.title'])}
        description={intl.formatMessage(
          messages['companyLandingPage.description'],
        )}
        textWithImageComponents={(
          <>
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.premiumEmployer.buttonLabel'],
              )}
              buttonRoute={`submit-job-postings.${locale}`}
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.premiumEmployer.description'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.premiumEmployer}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.premiumEmployer,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.premiumEmployer.title'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.employerBranding.buttonLabel'],
              )}
              buttonRoute="employer-branding"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.employerBranding.description'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.employerBranding}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.employerBranding,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.employerBranding.title'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.contentMarketing.buttonLabel'],
              )}
              buttonRoute="content-marketing"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.contentMarketing.description'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.contentMarketing}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.contentMarketing,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.contentMarketing.title'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.displayAdvertising.buttonLabel'],
              )}
              buttonRoute="display-advertising"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.displayAdvertising.description'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.displayAdvertising}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.displayAdvertising,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.displayAdvertising.title'],
              )}
            />
          </>
        )}
        uniqueSellingProposition={
          <UniqueSellingProposition items={uniqueSellingPropositionItems} />
        }
      />
      <PageCardContainer pageCards={cardsData.map(({
        title,
        description,
        route,
        cardImageUrls: originalCardImageUrls,
      }) => {
        const { imageUrls: cardImageUrls, srcSet } = getProxiedImages(
          { imageConfigurations: companyProfilesCardImageConfigurations },
          originalCardImageUrls,
        );

        return (
          <LinkAndAnchor key={title} route={route} display="flex">
            <AdaptiveCard
              title={title}
              textAlign="left"
              description={description}
              image={cardImageUrls[0] && (
              <ImageWithUrls
                sizes={`
                      (min-width: 1440px) 318px,
                      (min-width: ${breakpoints.lg}px) calc(25vw - 42px),
                      (min-width: ${breakpoints.md}px) calc(50vw - 52px),
                      calc(100vw - 72px)
                    `}
                srcSet={srcSet}
                imageUrls={cardImageUrls}
                alt={title}
                disableRoundedCorners
              />
              )}
            />
          </LinkAndAnchor>
        );
      })}
      />
    </>
  );
};

CompanyPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Company page banner image"
      />
    )}
  >
    {page}
  </Layout>
);

export default CompanyPage;
